import styled from "styled-components";




export const Slider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    

    &::before{
        position: absolute;
        content: "";
        height: 17px;
        width: 17px;
        left: 4px;
        bottom: 4px;
        background-color: ${(props) => props.theme.mainBackground};
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 50%;
    }
`

export const CheckBox = styled.input`
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + ${Slider}{
        background-color: ${(props) => props.theme.secondaryBackground};

    &:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
    }
    &:focus + ${Slider}{
        box-shadow: 0 0 1px ${(props) => props.theme.secondaryBackground};
    }
    
`


export const Switch = styled.label`
    position: relative;
    display: inline-block;
    width: 50px;
    height: 25px;
    border-radius: 20px;
    overflow: hidden;
    background-color: transparent;
`

